import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=216fa884&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=ts&"
export * from "./Loader.vue?vue&type=script&lang=ts&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=216fa884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216fa884",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2898369969/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216fa884')) {
      api.createRecord('216fa884', component.options)
    } else {
      api.reload('216fa884', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=216fa884&scoped=true&", function () {
      api.rerender('216fa884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/loaders/Loader.vue"
export default component.exports